<template>
  <div class="">
    <radial-progress-bar
      class="progress"
      :diameter="120"
      innerStrokeColor="#898989"
      :strokeWidth="5"
      :innerStrokeWidth="6"
      :completed-steps="moviesRecommended_watched.watched"
      :total-steps="moviesRecommended_watched.total"
    >
      <div class="progress-content">
        <div>
          {{ moviesRecommended_watched.watched }} /
          {{ moviesRecommended_watched.total }}
        </div>
        <div>
          <font-awesome-icon icon="eye" />
        </div>
      </div>
    </radial-progress-bar>
  </div>
</template>

<script>
import RadialProgressBar from "vue-radial-progress";

import { mapState } from "vuex";

export default {
  components: {
    RadialProgressBar,
  },

  data: () => ({}),

  computed: mapState(["moviesRecommended_watched"]),
  watch: {
    moviesRecommended_watched() {
      console.log(this.moviesRecommended_watched);
    },
  },
};
</script>

<style scoped>
.container {
  position: relative;
  display: flex;
  justify-content: flex-end;
}

.progress-circle {
  position: relative;
  display: inline-block;
  margin: 1rem;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: #ebebeb;
}

.progress-content > div {
  color: #91c257;
  margin: 5px;
  height: 20px;
  font-size: 20px;
  font-weight: bolder;
  text-align: center;
}
.progress-content {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  justify-items: space-around;
  align-content: space-around;
  align-items: space-around;
}
</style>
